module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_5010.251a9350.png";